module.exports = __webpack_public_path__ + "static/media/stats-icon.dae8b695.svg";